export enum EFileUploaderState {
  ERROR = 'error',
  SEND = 'send',
  LOADING = 'loading',
  WAITING = 'waiting'
}
